import api, { API_BASE, defaultOpt } from "./apiService";
import { rowTransform } from "./tableUtils";

export async function getAllShipments() {
  return (await api.get(`${API_BASE}/list-shipment`)).data;
}

export async function addShipment(formAdd) {
  return (await api.post(`${API_BASE}/add-shipment`, formAdd, defaultOpt()))
    .data;
}

export async function deleteShipment(id) {
  return (await api.delete(`${API_BASE}/delete-shipment/${id}`, defaultOpt()))
    .data;
}

export async function updateShipment(id, form) {
  return (await api.put(`${API_BASE}/edit-shipment/${id}`, form, defaultOpt()))
    .data;
}

export function makeShipmentOptions(shipmentList) {
  return rowTransform(shipmentList, (ship) => ({
    value: ship.id,
    label: `${ship.id} (${ship.box_desc})`,
  }));
}

export const destinationOptions = [
  { value: "CMU", label: "(CMU) Carnegie Mellon University" },
  { value: "IHEP", label: "(IHEP) Institute for High Energy Physics" },
  { value: "TIFR", label: "(TIFR) Tata Institute of Fundamental Research" },
  { value: "TTU", label: "(TTU) Texas Tech University" },
  { value: "NTU", label: "(NTU) National Taiwan University" },
  { value: "UCSB", label: "(UCSB) University of California, Santa Barbara" },
];
